import itemTracking from './Item Tracking.png';
import workInProcess from './WIP.png';
import assetTracking from './AT.png';
import metaDataCreator from './MetaDataCreator.png';
import nucleus from './Nucleus.png';
import rex from './rex.png';
import flair from './flair.png';
import redbeam from './RedbeamAT.png';
import sstBall from './sst-ball.png';
import redbeamBall from './redbeam-ball.png';

const useCaseImages = {
    'Item Tracking': { path: 'Item Tracking.png', image: itemTracking },
    'Work In Process': { path: 'WIP.png', image: workInProcess },
    'Asset Tracking': { path: 'AT.png', image: assetTracking },
    'Inventory Tracking': { path: 'redbeam-ball.png', image: redbeamBall },
    MetaDataCreatorV3: { path: 'MetaDataCreator.png', image: metaDataCreator },
    Nucleus: { path: 'Nucleus.png', image: nucleus },
    REX: { path: 'rex.png', image: rex },
    FLAIR: { path: 'flair.png', image: flair },
    RedBeam: { path: 'RedbeamAT.png', image: redbeam },
    'RedBeam RFID': { path: 'redbeam-ball.png', image: redbeamBall  },
    'RFID': { path: 'redbeam-ball.png', image: redbeamBall },
    default: { path: 'sst-ball.png', image: sstBall }
};

export default useCaseImages;
